module.exports = __webpack_public_path__ + "img/app_icon_34.03726b6c.png";